import Progressbar from 'emerald-ui/lib/Progressbar';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Progressbar, componentName: 'Progressbar' }], 'Progressbar'),
  description: 'A Progressbar shows how complete, in percentages, a process is.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Progressbar },
      whiteBackground: true,
      code: `<Progressbar progress={50} />`,
    },
  ],
};
